import axiosInstance from 'ns_libs/nsAxios';
import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import { IProFormaData } from 'views/ProFormaTable/types';
import { trackDatadogRumError } from 'utils/initDatadogRum';

const getProFormaModels = async (): Promise<IProFormaData[]> => {
    const response = await axiosInstance.get(API_ENDPOINTS.PRO_FORMA_MODELS);
    if (!Array.isArray(response.data)) {
        trackDatadogRumError(
            new Error('[useProFormaModels] Expected array response'),
            { receivedType: typeof response.data, receivedValue: response.data },
        );
        return [];
    }
    return response.data;
};

const useProFormaModels = () => useQuery({
    queryKey: ['proFormaModelOptions'],
    queryFn: () => getProFormaModels(),
});

export default useProFormaModels;
